import React from "react";
import { clearCategories, deselectCategory, loadCategoryNodes, selectCategory, setSelectedCategoryIds } from "../../actions/categories";
import { CategoriesStore } from "../../stores/categories";
import { connect } from "../../utils/aj-react";
import { TreeSelector } from "./treeSelector";
import M from "../../strings";
import { Control } from "./forms";
import _ from "underscore";

function getCategoryLabel(n) {
    let prefix = "";
    if (n.category?.level == 0) {
        prefix = M("macroarea") + ": ";
    } else if (n.category?.level == 1) {
        prefix = M("area") + ": ";
    }

    return prefix + n.category?.description ?? "NA";
}

function getCategoryId(n) {
    return n.id;
}

export const CategoriesTreeSelector = connect(TreeSelector).to(CategoriesStore, 
    (state) => ({
        nodes: state.categoryNodes,
        selectedNodes: state.selectedCategoryIds,
        inputValues: state.inputValues,
        labelSupplier: getCategoryLabel,
        idSupplier: getCategoryId,
        childrenProperty: "children",
    }),
    (props) => ({
        onInit: (props) => {
            if (!props.manualLoad) {
                loadCategoryNodes();
            }
        },
        onDestroy: (props) => {
            if (!props.manualLoad) {
                clearCategories();
            }
        },
        onUpdate: (props, state) => {
            if (_.isFunction(props.onUpdateCategories)) {
                props.onUpdateCategories(state.selectedCategoryIds);
            }
        },
        onSelect: node => selectCategory(node),
        onDeselect: node => deselectCategory(node),
    })
)

export class CategoriesTreeSelectorControl extends Control {

    componentDidMount() {
        this.props.model.once("load", () => {
            setSelectedCategoryIds(this.props.model.get("allowedCategoryIds"));
        })
    }

    onUpdateCategories(categoryIds) {
        const model = this.props.model;
        model.set("allowedCategoryIds", categoryIds);
    }

    render() {
        return <CategoriesTreeSelector startsCollapsed={true} onUpdateCategories={this.onUpdateCategories.bind(this)} />
    }

}